const SIDES = ['right', 'left', 'top', 'bottom'];
const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

export function hotspotNumberPlacement({ image, frame, number, preferredSide = 'right', gap = 8 }) {
  const halfWidth = Math.min(number.width, image.width) / 2;
  const halfHeight = Math.min(number.height, image.height) / 2;
  const center = { x: frame.x + frame.width / 2, y: frame.y + frame.height / 2 };
  const positions = {
    right: { x: frame.x + frame.width + gap + halfWidth, y: center.y },
    left: { x: frame.x - gap - halfWidth, y: center.y },
    top: { x: center.x, y: frame.y - gap - halfHeight },
    bottom: { x: center.x, y: frame.y + frame.height + gap + halfHeight },
  };
  const sides = [preferredSide, ...SIDES.filter((side) => side !== preferredSide)];
  const side = sides.find((candidate) => {
    const position = positions[candidate];
    return position.x >= halfWidth && position.x <= image.width - halfWidth
      && position.y >= halfHeight && position.y <= image.height - halfHeight;
  }) || preferredSide;
  return {
    side,
    x: clamp(positions[side].x, halfWidth, image.width - halfWidth),
    y: clamp(positions[side].y, halfHeight, image.height - halfHeight),
  };
}
